import { Button, Modal } from "react-bootstrap";

const TermsAndConditionsModal = ({ show, onHide, onAccept }) => {
  return (
    <Modal show={show} onHide={onHide} centered scrollable size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Terms and Conditions</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ maxHeight: "60vh", overflowY: "auto" }}>
        <h6>1. Acceptance of Terms</h6>
        <p>
          By creating an account with SignBook, you agree to be bound by
          these Terms and Conditions, whether you are registering as an
          individual or on behalf of a business.
        </p>

        <h6>2. Use of E-Signature Services</h6>
        <p>
          SignBook provides digital signature services for documents.
          Signatures created via the platform are intended to be legally
          binding to the extent permitted by applicable law in your
          jurisdiction.
        </p>

        <h6>3. Account Responsibility</h6>
        <p>
          You are responsible for maintaining the confidentiality of your
          account credentials and for all activity that occurs under your
          account.
        </p>

        <h6>4. Business Accounts</h6>
        <p>
          If registering on behalf of a company, you confirm that you are
          authorized to bind that organization to these terms.
        </p>

        <h6>5. Data & Privacy</h6>
        <p>
          Documents and personal data submitted to SignBook are processed in
          accordance with our Privacy Policy.
        </p>

        <h6>6. Termination</h6>
        <p>
          SignBook reserves the right to suspend or terminate accounts that
          violate these terms.
        </p>

        {/* Replace the above with your actual legal copy */}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
        <Button variant="primary" onClick={onAccept}>
          I Accept
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default TermsAndConditionsModal;